import * as React from "react";
import {map as _map} from "lodash";

export interface IToggleButtonInfo {
    display: string,
    meta: any
}

export interface IToggleButtonProps {
    toggleButtonInfos: IToggleButtonInfo[],
    startSelIdx: number,
    onToggleButtonClick: (meta: any) => void
}

export interface IToggleButtonState {
    selectedButtonIdx: number
}

class ToggleButtonGroup extends React.Component<IToggleButtonProps, IToggleButtonState> {

    constructor(props: IToggleButtonProps) {
        super(props);
        this.state = {
            selectedButtonIdx: this.props.startSelIdx
        }
    }

    handleToggleButtonClick(index: number, meta: any): void {
        if (this.state.selectedButtonIdx !== index) {
            this.props.onToggleButtonClick(meta);
            this.setState({selectedButtonIdx: index});
        }
        // if (this.props.onToggleButtonClick(meta)) {
        //     this.setState({selectedButtonIdx: index});
        // }
    }

    render() {
        let myInstance = this;
        return (
            <div className="toggle-button-group">
                {
                    _map(this.props.toggleButtonInfos, function(toggleButtonInfo: IToggleButtonInfo, index: number){
                       let selectedCls = myInstance.state.selectedButtonIdx === index ? "selected" : "";
                       return (
                           <div onClick={() => {myInstance.handleToggleButtonClick(index, toggleButtonInfo.meta)}}
                                className={"toggle-button " + selectedCls}
                                key={index}>
                               {toggleButtonInfo.display}
                           </div>
                       )
                    })
                }
            </div>
        )
    }
}

export default ToggleButtonGroup